export default "__VITE_ASSET__DEvQjAdh__"